import React from "react";
import headerImage from "../../assets/header4.jpg";
import { CopyBlock, dracula } from "react-code-blocks";
import week11_led from "../../assets/week11_led.jpg";
import week11_led2 from "../../assets/week11_led2.jpg";
import week11_udp from "../../assets/week11_udp.jpg";
import week11_import from "../../assets/week11_import.png";


const Assignment12 = () => {


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 11: Networking and Communication</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">Mai 24, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}


        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
        This week is about transmitting signals over a <strong>network</strong> and allowing multiple devices to communicate with each other. 
        I used my development board I produced for  
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/assignments/10" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          input week
        </a> to
 carry out the test as well as a W2812B LED ring and my laptop.


</p>

<div className="text-gray-700 space-y-4 mt-6">
<h2 className="text-2xl font-bold text-left mb-2">LED Control via command line</h2>


        <p className="text-justify text-gray-700 mb-6">
        First, I connected the NEO Pixel Ring to my dev board and wrote a sketch to control the colors and brightness of the LED ring via command line.
</p>

        <p className="text-justify text-gray-700 mb-6">
        I downloaded and installed the Arduino library to control the Neopixel.</p>
        <p className="text-justify text-gray-700 mb-6">
        Then I wrote a sketch that accepts the commands as words in the command line and controls the colors and brightness of the ring. I also programmed a rainbow mode and a mode in which the ring rotates. </p>
        <p className="text-justify text-gray-700 mb-6">
        After this first functional test of the DevBoard in combination with the Neopixel Ring was completed, I then took care of the implementation of the Wifi connectivity.
        </p>


        <h2 className="text-2xl font-bold text-left mb-2"> Controlling the LED Via UDP</h2>

         <p className="text-justify text-gray-700 mb-6">
         My next goal was to be able to control the LED ring via UDP over the WLAN. So I extended my original sketch so that the dev board connects to the WiFi and can receive messages via UDP.

         </p>
         <p className="text-justify text-gray-700 mb-6">
         To do this, I had to install and import the WiFi.h and WiFiUDP.h libraries in the Arduino IDE.

         <img src={week11_import} alt="" className="my-4 mx-auto rounded shadow-md" />
In the setup of the program, WiFi.begin(ssid, password) is used to establish a connection. The password and the name of the WiFi are previously created as variables in the code. </p>
         <p className="text-justify text-gray-700 mb-6">
         WiFi.begin(...) starts the connection process.
</p>
         <p className="text-justify text-gray-700 mb-6">
         The while loop checks every 500 ms whether the connection is already established.</p>
         <p className="text-justify text-gray-700 mb-6">
         If not: It waits and continues to check.</p>

 <CopyBlock
              text={`void setup() {

Serial.begin(115200);

Serial.println("\nConnecting to WiFi...");

WiFi.begin(ssid, password)
while (WiFi.status() != WL_CONNECTED) 
 delay(500)
 Serial.print(".")

Serial.println("\n WiFi connected!")
Serial.print("IP address: ")
Serial.println(WiFi.localIP());

///...
  
 udp.begin(localPort);
 Serial.print("UDP listening on port ");
 Serial.println(localPort);

}
                `}
              language="C"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />



         <p className="text-justify text-gray-700 mb-6">
         Then the local IP is written to the serial monitor and with udp.begin(localPort) the ESP32 opens a local UDP port (here 4210) and is  ready to receive incoming UDP packets.</p>
         <p className="text-justify text-gray-700 mb-6">
         Since UDP is connectionless, unlike TCP, it does not require a connection to be established and therefore no handshake. The packets are simply sent and, if possible, received. The protocol has no control mechanisms to check whether the packets arrive. If this is required, it must be implemented in the program.
        In the loop(), udp.parsePacket() is later used to check whether a new UDP packet has arrived and the number of bytes received is saved. Then a char array with the variable name incoming is created, which contains 255 characters and the message is stored in the array with udp.read(incoming, 255). The variable len contains the actual number of characters read and if (len > 0) incoming[len] = ‘\0’; inserts a null terminator at the last position of the array so that it is a valid C string. With processCommand(String(incoming)); the array is first converted into a string and then passed to the processCommand method.</p>
         
         
         
<CopyBlock
              text={`void processCommand(String input) {

  input.trim();

  input.toLowerCase();

  if (input.startsWith("brightness")) {
    int value = input.substring(10).toInt();
    value = constrain(value, 0, 100);
    currentBrightness = map(value, 0, 100, 0, 255);
    ring.setBrightness(currentBrightness);
    applyColor(lastColor);
    Serial.print("Brightness set to ");
    Serial.println(value);
  }

  else if (input == "on") {
    applyColor(lastColor);
  }
  else if (input == "off") {
    applyColor("off");
  }
  else if (input == "turn") {
    turnClockwise(lastColor);
    applyColor(lastColor);
  }
  else if (input == "rainbow") {
    rainbow(50);
  }
  else {
    applyColor(input);
  }
}

                `}
              language="C"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />    
         
         
         
         
         <p className="text-justify text-gray-700 mb-6">
         At first I had problems connecting the ESP32 to the WiFi. Without the supplied antenna, the DevBoard could not connect to the WiFi. I initially assumed that the board also had an integrated antenna, like the classic ESP32, and therefore had to search for the error for a while.</p>
         <p className="text-justify text-gray-700 mb-6">
         However, after connecting the antenna, the devboard connected to the Wifi and I was able to send the commands via UDP.</p>

         <img src={week11_udp} alt="" className="my-4 mx-auto rounded shadow-md" />



         <h2 className="text-2xl font-bold text-left mb-2"> Sending messages with Powershell via UDP</h2>

<p className="text-justify text-gray-700 mb-6">
In order to be able to transmit a corresponding UDP message from the laptop, I first used Windows Powershell to specify the IP and port of the recipient with a "Send-UDP" function and created a client and endpoint. [string]$message is the variable name of the parameter that is to be sent as a message by the function. The message is then sent with udpClient.Send to the remote endpoint (the ESP32) using udp.Client.Send().</p>

<CopyBlock
              text={`function Send-UDP {
    param (
        [string]$ip = "192.168.2.147",
        [int]$port = 4210,
        [string]$message
    )
    $udpClient = New-Object System.Net.Sockets.UdpClient
    $remoteEndpoint = New-Object System.Net.IPEndPoint ([System.Net.IPAddress]::Parse($ip), $port)
    $bytes = [System.Text.Encoding]::ASCII.GetBytes($message)
    $udpClient.Send($bytes, $bytes.Length, $remoteEndpoint)
    $udpClient.Close()
}                `}
              language="powershell"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />   




<p className="text-justify text-gray-700 mb-6">
The function can then be used in Powershell with Send-UDP. The parameter for the message, the desired string to be transmitted, is transferred with -message.</p>
<p className="text-justify text-gray-700 mb-6">
...</p>

<CopyBlock
              text={`Send-UDP -message "purple"
Send-UDP -message "brightness 40"
Send-UDP -message "turn"                `}
              language="powershell"
              showLineNumbers={false}
              theme={dracula}
              codeBlock
            />   

<img src={week11_led} alt="" className="my-4 mx-auto rounded shadow-md" />
<img src={week11_led2} alt="" className="my-4 mx-auto rounded shadow-md" />




   <h2 className="text-2xl font-bold text-left mb-2">Group Assignment</h2>

<p className="text-justify text-gray-700 mb-4">
For the group assignment we sent a message between Julians and my dev board. You can find the detailed description on 
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/Assignments/week11/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          group documentation page 
        </a>.
      </p>


      <h2 className="text-2xl font-bold text-left mb-2">Downloads</h2>

      <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/wifi_led_controller.ino"
    download
  >
    📎 Download Code
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/LEDController.ino"
    download
  >
    📎 Download Code
  </a>
        </div>

</div>

  );
};

export default Assignment12;
